import { useCallback } from "react";
import ReduxFetchState from "redux-fetch-state";
import { put, select, takeEvery } from "redux-saga/effects";
import axios from "../../../../Utils/axiosConfig";
import { getCurrentLanguage } from "../../../../Utils/sagaHelpers";
import { useAppDispatch, useAppSelector } from "../../../../Hooks/useStore";
import { alert } from "../../../../Utils/toast";
import { closeModal } from "../../modal/modal";
import { agencyRawDataListActions } from "../agencyRawDataList/agencyRawDataList";

export type AgencyRawDataDeleteLoadAction = {
  type: string;
  payload: { id: number | string; agencyId: number | string };
};

export type AgencyRawDataDeleteData = {
  data?: { message?: string };
  message?: string;
};

const AgencyRawDataDelete = new ReduxFetchState<
  AgencyRawDataDeleteData | null,
  { id: number | string; agencyId: number | string },
  any
>("agencyRawDataDelete");

export function* watchAgencyRawDataDelete(action: AgencyRawDataDeleteLoadAction) {
  try {
    const lang: "fa" | "en" = yield getCurrentLanguage();
    const { id, agencyId } = action.payload;

    const data: AgencyRawDataDeleteData = yield axios({
      url: `api/v1/ai/agency/raw-data/${id}`,
      method: "DELETE",
      headers: { lang },
    });

    yield alert({
      message: data?.data?.message ?? data?.message ?? "با موفقیت حذف شد.",
      type: "success",
    });
    yield put(AgencyRawDataDelete.actions.loadSuccess({ data: data.data ?? data }));
    yield put(closeModal());

    const listState: { data?: { data?: { current_page?: number } } } = yield select(
      (state: any) => state.agencyRawDataList,
    );
    const page = listState?.data?.data?.current_page || 1;

    yield put(agencyRawDataListActions.load({ id: agencyId, page }));
  } catch (e: any) {
    alert({
      message: e?.response?.data?.error ?? e?.response?.data?.message ?? "مشکلی پیش آمده",
      type: "error",
    });
    yield put(AgencyRawDataDelete.actions.loadFailure(e.message));
  }
}

export function* agencyRawDataDeleteSagas() {
  yield takeEvery(AgencyRawDataDelete.actionTypes.load, watchAgencyRawDataDelete);
}

export function useAgencyRawDataDelete() {
  const { loading, data, ...agencyRawDataDeleteState } = useAppSelector(
    (state) => state.agencyRawDataDelete,
  );
  const dispatch = useAppDispatch();

  const dispatchAgencyRawDataDelete = useCallback(
    (payload: { id: number | string; agencyId: number | string }) => {
      dispatch(AgencyRawDataDelete.actions.load(payload));
    },
    [dispatch],
  );

  return {
    ...agencyRawDataDeleteState,
    dispatchAgencyRawDataDelete,
    agencyRawDataDeleteLoading: loading,
    agencyRawDataDeleteData: data,
  };
}

export const {
  actionTypes: agencyRawDataDeleteActionsTypes,
  actions: agencyRawDataDeleteActions,
  reducer: agencyRawDataDeleteReducer,
} = AgencyRawDataDelete;